import { Component } from '@angular/core';
import { StatisticsService } from '../../../../services/statistics.service';
import { CommonModule, formatDate } from '@angular/common';
import { DesignAngularKitModule, ItNotificationService, NotificationPosition } from 'design-angular-kit';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { format } from 'date-fns';
import { it } from 'date-fns/locale';

@Component({
  selector: 'app-stats-table',
  standalone: true,
  imports: [
    CommonModule,
    DesignAngularKitModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './stats-table.component.html',
  styleUrl: './stats-table.component.scss',
})
export class StatsTableComponent {
  form: FormGroup;
  data: { totals: any; values: any[]; } = {totals: null, values: []};
  sortedData: any[] = [];
  totals: any = {};
  selectedStartDate: string | null = null;
  selectedEndDate: string | null = null;
  year: string | null = null;
  trimestre: string | null = null;

  constructor(
    private statisticsService: StatisticsService,
    private fb: FormBuilder,
    private notification: ItNotificationService
  ) {
    const currentYear = new Date().getFullYear();
    const currentDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.form = this.fb.group({
      dataInizio: [`${currentYear}-01-01`],
      dataFine: [`${currentDate}`],
      state: ['ALL']
    });
  }

  ngOnInit(): void {
    this.form.get('state')?.setValue('ALL');
    this.search();
  }

  selectedTrimester() {
    if(this.trimestre == '1') {
      this.form.controls['dataInizio'].setValue(this.year+'-01-01');
      this.form.controls['dataFine'].setValue(this.year+'-03-31');
    }
    if(this.trimestre == '2') {
      this.form.controls['dataInizio'].setValue(this.year+'-04-01');
      this.form.controls['dataFine'].setValue(this.year+'-06-30');
    }
    if(this.trimestre == '3') {
      this.form.controls['dataInizio'].setValue(this.year+'-07-01');
      this.form.controls['dataFine'].setValue(this.year+'-09-30');
    }
    if(this.trimestre == '4') {
      this.form.controls['dataInizio'].setValue(this.year+'-10-01');
      this.form.controls['dataFine'].setValue(this.year+'-12-31');
    }
  }

  search() {
    
    const { dataInizio, dataFine } = this.form.value;
    if(dataInizio.substring(0,4)<2024) {
      this.notification.warning(
              'Attenzione.',
              'Non è possibile fare una ricerca per pratiche antecedenti al 2024.',
              true,
              3000,
              NotificationPosition.Top
            );
            return;
    }
    this.selectedStartDate = dataInizio;
    this.selectedEndDate = dataFine;

    this.statisticsService
      .getStats({
        startDate: dataInizio,
        endDate: dataFine,
        state: this.form.controls['state'].value
      })
      .subscribe((res) => {
        this.data = res;
        this.sortedData = this.sortData(this.data.values);
        this.computeTotals();
      });
  }

  clearFilter() {
    this.form!.patchValue({ dataInizio: null, dataFine: null, state:'ALL' });
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.search();
  }

  sortData(data: any[]): any[] {
    const sorted = [...data].sort((a, b) => {
      const nameA = a.setting.toLowerCase();
      const nameB = b.setting.toLowerCase();
      if (nameA === 'altro') return 1;
      if (nameB === 'altro') return -1;
      return nameA.localeCompare(nameB);
    });
    return sorted;
  }

  computeTotals() {
    this.totals = {};
    this.totals = this.data.totals;
    // for (const key of keys) {
    //   this.totals[key] = this.data.reduce(
    //     (sum, row) => sum + (row[key] || 0),
    //     0
    //   );
    // }
  }

  formatSetting(setting: string): string {
    if (setting?.toLowerCase() === 'altro') {
      return 'Altro';
    }
    return setting;
  }

  formatDateIT(dateStr: string | null): string {
    if (!dateStr) return '';
    return format(new Date(dateStr), 'dd/MM/yyyy', { locale: it });
  }
}
